import { useTheme } from "@mui/system";
import { FC } from "react";
import ReactApexChart from "react-apexcharts";

const PieChart: FC = () => {
  const theme = useTheme();

  const series = [44, 55, 13, 43, 22, 20];
  const options: object = {
    chart: {
      type: "pie",
    },
    colors: [
      theme.palette.primary.dark,
      theme.palette.primary.main,
      theme.palette.primary.light,
      theme.palette.primary[400],
      theme.palette.primary[300],
      theme.palette.primary[200],
    ],
    stroke: {
      show: true,
      width: 0,
      colors: ["transparent"],
    },
    legend: {
      show: false,
    },
  };
  return (
    <ReactApexChart options={options} series={series} type="pie" height={240} />
  );
};

export default PieChart;
